import { NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SharedContentModule } from '../shared/shared.module';

import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { InputsModalComponent } from './inputs-modal/inputs-modal.component';
import { AudioVideoModalComponent } from './audio-video-modal/audio-video-modal.component';
import { FileUploadModalComponent } from './file-upload-modal/file-upload-modal.component';

const OVERLAYS: Type<any>[] = [
    ConfirmModalComponent,
    InputsModalComponent,
    AudioVideoModalComponent,
    FileUploadModalComponent,
];

@NgModule({
    declarations: [...OVERLAYS],
    imports: [CommonModule, FormsModule, SharedContentModule],
    exports: [...OVERLAYS],
    entryComponents: [...OVERLAYS],
})
export class SharedOverlaysModule {}
